import { toggleNav } from '../js/main'
import '../css/reset.css'
import '../css/constants.css'
import '../css/main.css'
import './mixing-consultancy.css'
import gsap from 'gsap';
toggleNav()
console.log('this is Consultancy page');
function revealPage () {
    const tl = new gsap.timeline()
    tl.set(document.querySelector('body'), {
        visibility: 'visible',
    })
    .set([...document.querySelectorAll('.service-title'),
    ,...document.querySelectorAll('.service-info')], {
        opacity: 0,
        x: 0,
        y: 5,
    })
    .to(document.querySelectorAll('.service-title'), {
        y: 0,
        opacity: 1,
        ease: 'sine',
        duration: 0.4,
        stagger: 0.2,
    })
    .to(document.querySelectorAll('.service-info'), {
        y: 0,
        opacity: 1,
        ease: 'sine',
        duration: 0.4,
        stagger: 0.2,
        delay: 0.2
    }, '<')
    return tl
}
revealPage()